export default __webpack_public_path__ + "static/media/wheat-mountain.51e466b3.svg";